export default {corgi:{petition_gamma:{petition_sign:{address:{presence:'Please enter an address.'}}}}};